// extracted by mini-css-extract-plugin
export default {"printReview":"ConfirmationEmail-module__printReview--y45Vy"};